interface SkillCategory {
  category: string;
  skills: string[];
  colorClass: string;
}

function Skills(): JSX.Element {
  const skillCategories: SkillCategory[] = [
    {
      category: "Languages",
      skills: ["JavaScript", "PHP", "Python", "SQL and PL/PgSQL", "Bash"],
      colorClass: "text-red-800"
    },
    {
      category: "Frontend",
      skills: ["Vue.js", "Phaser.js", "CSS", "HTML", "jQuery"],
      colorClass: "text-blue-800"
    },
    {
      category: "Backend",
      skills: ["Node.js", "Laravel", "Supabase", "Magento", "ORM"],
      colorClass: "text-green-800"
    },
    {
      category: "DevOps",
      skills: ["Wide number of AWS services", "Kubernetes", "Terraform", "Docker", "CI/CD"],
      colorClass: "text-purple-800"
    },
    {
      category: "Tools",
      skills: ["GitLab", "Varnish", "Redis", "Grafana", "Jenkins"],
      colorClass: "text-orange-800"
    },
    {
      category: "Cloud Services",
      skills: ["AWS", "GCP", "DigitalOcean"],
      colorClass: "text-indigo-800"
    },
    {
      category: "Testing",
      skills: ["Cypress", "Jest", "End-to-End Testing", "PHPUnit"],
      colorClass: "text-yellow-800"
    },
    {
      category: "Automation",
      skills: ["CI/CD", "IaC", "Auto-scaling", "Monitoring", "Testing", "Media Processing"],
      colorClass: "text-gray-800"
    },
    {
      category: "AI & LLM",
      skills: ["Claude Code", "MCP Servers", "RAG & Embeddings", "OpenAI API", "Prompt Engineering", "Multi-Agent Systems"],
      colorClass: "text-teal-800"
    }
  ];

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Skills</h2>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {skillCategories.map((category: SkillCategory, index: number) => (
          <div key={index}>
            <h3 className="text-lg font-semibold text-gray-800 mb-3">{category.category}</h3>
            {category.skills.length > 0 ? (
              <div className="flex flex-wrap gap-2">
                {category.skills.map((skill: string) => (
                  <span 
                    key={skill} 
                    className={`px-3 py-1 bg-white ${category.colorClass} rounded-full text-sm border`}
                  >
                    {skill}
                  </span>
                ))}
              </div>
            ) : (
              <p className="text-gray-500 italic">Skills in development</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Skills;